import { CreditCard, Wallet, Smartphone, Building2, Coins } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { PAYMENT_METHODS } from '@/lib/api';

const iconFor = (id) => {
  if (id === 'visa') return CreditCard;
  if (id === 'wire') return Building2;
  if (id === 'pi_network') return Coins;
  if (id === 'airtel_money' || id === 'orange_money' || id === 'mpesa' || id === 'africell') return Smartphone;
  return Wallet;
};

const methodColor = (id) => ({
  airtel_money: 'bg-red-100 text-red-700',
  orange_money: 'bg-orange-100 text-orange-700',
  mpesa: 'bg-emerald-100 text-emerald-700',
  africell: 'bg-purple-100 text-purple-700',
  visa: 'bg-blue-100 text-blue-700',
  wire: 'bg-slate-100 text-slate-700',
  pi_network: 'bg-yellow-100 text-yellow-700',
}[id] || 'bg-slate-100 text-slate-700');

export const PaymentMethodPicker = ({ value, onChange }) => (
  <RadioGroup value={value} onValueChange={onChange} className="space-y-2">
    {PAYMENT_METHODS.map((m) => {
      const Icon = iconFor(m.id);
      const selected = value === m.id;
      return (
        <label key={m.id} className="block">
          <Card
            data-testid={`payment-method-radio-${m.id}`}
            className={`p-3 cursor-pointer border ${selected ? 'border-[#1677F2] bg-[#F2F8FF] ring-2 ring-[#1677F2]/20' : 'border-[#E2E8F0] hover:border-[#C7E2FF]'}`}
          >
            <div className="flex items-center gap-3">
              <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${methodColor(m.id)}`}>
                <Icon size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm text-[#0B1220]">{m.label}</p>
                <p className="text-xs text-slate-600">{m.desc}</p>
              </div>
              <RadioGroupItem value={m.id} id={m.id} data-testid={`payment-method-radioinput-${m.id}`} />
            </div>
          </Card>
        </label>
      );
    })}
  </RadioGroup>
);
